import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import encodeImage from './encodeImages';

class PopoutWindow extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    const optionString = `width=${this.props.width}, height=${this.props.height}`;
    this.popoutWindow = window.open(
      '',
      '',
      'toolbar=no,menubar=no,resizable=yes,status=no',
      optionString
    ); //open a new window
    if (props.title) {
      this.popoutWindow.document.title = props.title;
    }
    this.popoutContainer = this.popoutWindow.document.createElement('div');
  }

  componentDidMount() {
    //handling styles and images
    this.popoutWindow.onunload = () => {
      this.props.onPopupOutClose();
    };
    copyStyles(document, this.popoutWindow.document); //copy the styles
    this.popoutWindow.document.body.appendChild(this.popoutContainer); //append the content
    loadImages(this.popoutWindow.document, this.props.imageUrlMap); //inject data url into images
  }

  componentWillUnmount() {
    this.popoutWindow.onunload = () => {};
    this.popoutWindow.document.body.removeChild(this.popoutContainer); //remove the content
    this.popoutWindow.close();
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.popoutContainer);
  }
}

const copyStyles = (sourceDoc, targetDoc) => {
  Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
    if (styleSheet.cssRules) {
      // copy <style> elements
      const newStyleTag = sourceDoc.createElement('style');

      Array.from(styleSheet.cssRules).forEach((cssRule, i) => {
        if (cssRule.cssText.indexOf('url("/src/assets/') >= 0) {
          //encode css rule if it contains images, eg label.css-label { background-image: url("/src/assets/uncheck.png"); }
          // styleSheet.deleteRule(i);
          newStyleTag.appendChild(
            sourceDoc.createTextNode(encodeImage(cssRule.cssText))
          );
        } else
          newStyleTag.appendChild(sourceDoc.createTextNode(cssRule.cssText));
      });

      targetDoc.head.appendChild(newStyleTag);
    } else if (styleSheet.href) {
      // copy <link> elements loading CSS from a URL
      const newLinkTag = sourceDoc.createElement('link');
      newLinkTag.rel = 'stylesheet';
      newLinkTag.href = styleSheet.href;
      targetDoc.head.appendChild(newLinkTag);
    }
  });
  //now we need to include font awesome  from cdn, as we cannot copy the font files to the target document
  const link = sourceDoc.createElement('link');
  link.rel = 'stylesheet';
  link.href =
    'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';
  targetDoc.head.appendChild(link);
};

const loadImages = (targetDocument, imageUrlMap) => {
  Object.keys(imageUrlMap).forEach((image) => {
    let querySelector = `img[title='${image}']`;
    const elements = targetDocument.querySelectorAll(querySelector);
    for (let i = 0; i < elements.length; i++) {
      let ele = elements[i];
      ele.src = imageUrlMap[image];
    }
  });
};

PopoutWindow.propTypes = {
  onPopupOutClose: PropTypes.func
};

PopoutWindow.defaultProps = {
  onPopupOutClose: () => {}
};

export default PopoutWindow;
